import { APICall } from './index';

const ControllerName = "user"

export const ChangeUserPassword = (PasswordData: any) => {
    return APICall("patch", ControllerName + "/changePassword", PasswordData)
}

export const ForgetUserPassword = (phone: string) => {
    return APICall("patch", ControllerName + "/ForgetPassword?PhoneNumber=" + phone)
}

export const ResetUserPassword = (ResetPasswordData: any) => {
    return APICall("patch", ControllerName + "/ResetPassword", ResetPasswordData)
}

export const Login = (dataObject: any) => {
    return APICall("post", "Auth/token", dataObject,
    )
}

export const Logout = () => {
    return APICall("post", "auth/logout", {})
}

export const VerifyAccount = (phonenumber: string, code: string) => {
    return APICall("patch", ControllerName + "/verifyAccount?phoneNumber=" + phonenumber + "&code=" + code)
}


export const verifyCode = (phonenumber: string, code: string) => {
    return APICall("patch", ControllerName + "/verifyCode", { phonenumber, code })
}





